import { formatHora, m } from "./dateUtils";
import {
  useVehiclesStore,
  NO_VEHICLE_ID,
  NO_VEHICLE_OPTION 
} from "../stores/useVehiclesStore";

export const horarioPrevistoPonto = (DATAHORA_INICIAL_PREVISTO, TEMPO_CHEGADA) => {
  const previsto =  m(DATAHORA_INICIAL_PREVISTO)
    .clone()
    .add(TEMPO_CHEGADA, 'minutes');

  return previsto ? formatHora(previsto, 'HH:mm') : '--:--';
};

export const getBgColorByStatus = (status, situacao, theme) => {
  switch (status) {
    case 1:
      return theme.palette.success.main;
    case 2:
      return theme.palette.warning.main;
    case 3:
      return theme.palette.error.main;
    case 5:
      return theme.palette.inferred.main;
    case 4:
    default:
      return situacao === 'Agendada'
        ? theme.palette.background.default
        : theme.palette.dark.main;
  }
};

export const getColorByStatus = (status, situacao, theme) => {
  switch (status) {
    case 1:
      return theme.palette.success.contrastText;
    case 2:
      return theme.palette.warning.contrastText;
    case 3:
      return theme.palette.error.contrastText;
    case 5:
      return theme.palette.inferred.contrastText;
    case 4:
    default:
      return situacao === 'Agendada'
        ? theme.palette.text.primary
        : theme.palette.dark.contrastText;
  }
};

export const OCORRENCIA = {
  NAO_REALIZADA: 1,
  ATRASADA: 2,
  ESTOURO_SLA: 3
};


export const MOTIVES = [
  {id: 0, label: 'Selecione o motivo'},
  {id: 1, label: 'Trânsito'},
  {id: 2, label: 'Acidente na via'},
  {id: 3, label: 'Quebra de veículo'},
  {id: 4, label: 'Interdição de via'},
  {id: 5, label: 'Itinerário divergente'},
  {id: 6, label: 'Não atendeu o ponto inicial'},
  {id: 7, label: 'Rastreador offline'},
  {id: 8, label: 'Viagem programada indevidamente'},
  {id: 9, label: 'Veículo sem rastreador'},
  {id: 10, label: 'Veículo divergente'},
  {id: 11, label: 'Linha atendida por carro de aplicativo'},
  {id: 12, label: 'Linha sem passageiro'}  
];

export const DELETE_MOTIVES = [
  {id: 0, label: 'Selecione o motivo'},
  {id: 8, label: 'Viagem programada indevidamente'},
  {id: 12, label: 'Linha sem passageiro'}  
];

export const VEHICLE_CHANGE_MOTIVES = [
  {id: 0, label: 'Selecione o motivo da troca'},
  {id: 13, label: 'Escala incorreta'},
  {id: 14, label: 'Quebra de veículo'},
  {id: 15, label: 'Absenteísmo'},
  {id: 16, label: 'Não informado TRF'} 
];

export const NO_VEHICLE_MOTIVES = [
  {id: 0, label: 'Selecione o motivo'},
  {id: 13, label: 'Escala incorreta'},
  {id: 17, label: 'Escala sem veículo definido'}
];

export const situacaoTripsTypes = [
    { id: 'agendada', label: 'Agendada' },
    { id: 'andamento', label: 'Em andamento' },
    { id: 'finalizada', label: 'Finalizada' },
    { id: 'nao_realizada', label: 'Não Realizada' },
];

export const desempenhoTripsTypes = [
  { id: 1, label: 'Pontual' },
  { id: 2, label: 'Adiantada' },
  { id: 3, label: 'Atrasada' }
];

export const getDiferencaKmRota = (
  kmsRodados,
  kmTotalRota
) => {

  const rodados = Number(kmsRodados) || 0;

  const rota = Number(kmTotalRota) || 0;

  if (
    rodados <= 0 ||
    rota <= 0
  ) {
    return null;
  }

  const diferenca = rodados - rota;

  if (diferenca === 0) {
    return null;
  }

  const km = Math.abs(diferenca);

  const tipo =
    diferenca > 0
      ? '+'
      : '-';

  return {
    km,
    tipo,
    excel: diferenca
  };
};

export function getVehiclePrefix(placa) {

    const normalizedPlaca =
        String(placa || '').trim();

    if (!normalizedPlaca) {
        return null;
    }

    const vehicle =
        useVehiclesStore
            .getState()
            .veiculosDisponiveisMap
            .get(normalizedPlaca);

    if (!vehicle?.label) {
        return null;
    }

    return vehicle.label
        .split('-')[0]
        .trim() || null;

};

export const getTipoEscala = (numSerie) => {

    const serie = String(
        numSerie ?? ''
    ).trim().toUpperCase();

    return !serie || serie.startsWith('TOR')
        ? 'TORRE'
        : 'INTEGRAÇÃO';

};

export function getVehicleLabel(vehicleId) {

  const vehiclesMap = useVehiclesStore.getState().veiculosDisponiveisMap;

  const id = String(vehicleId ?? '').trim();

  if (!id) {
    return '';
  }

  if (id === NO_VEHICLE_ID) {
    return NO_VEHICLE_OPTION.label;
  }

  return vehiclesMap.get(id)?.label ?? id;

}